var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2614",
  transform: "translate(-616 -456)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 40",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(616 456)",
  fill: "#fcdf41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M634.385 463.686l-.375-.375a1.063 1.063 0 00-1.5 0l-6.374 6.377-2.262-2.26a1.062 1.062 0 00-1.5 0l-.375.375a1.065 1.065 0 000 1.5l3.385 3.389a1.066 1.066 0 001.5 0l7.5-7.5a1.066 1.066 0 000-1.5z",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/addcopy.c065f6cd.svg";
export { SvgComponent as ReactComponent };